import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth-slice';
import themeReducer from './theme-slice';
import feedbackReducer from './feedback-slice';
import advisersReducer from './advisers-slice';
import clientsReducer from './clients-slice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer,
    feedback: feedbackReducer,
    advisers: advisersReducer,
    clients: clientsReducer,
  }
});

export type AdminPortalRootState = ReturnType<typeof store.getState>;
export type AdminPortalDispatch = typeof store.dispatch;